import { render } from "./DefaultDashboard.vue?vue&type=template&id=18a75739"
import script from "./DefaultDashboard.vue?vue&type=script&lang=js"
export * from "./DefaultDashboard.vue?vue&type=script&lang=js"

import "./DefaultDashboard.vue?vue&type=style&index=0&id=18a75739&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__